import { Autocomplete, TextField, useMediaQuery } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTheme } from "@emotion/react";
import { AuthContext } from "../../../../context/AuthContext";

const SelectWorkStation = ({
  value,
  onUpdate,
  label = "Assign To",
  disabled,
  enableAdd,
  onBlur,
  error,
  helperText,
  required,
  ...props
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { authToken, ezorder } = useContext(AuthContext);
  const [workStations, setWorkStations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  const getWorkStations = async (controller) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };
      if (controller) {
        data.signal = controller.signal;
      }

      const response = await ezorder.get(`/work-stations`, data);

      if (response.status == 200) {
        setWorkStations(response.data.workStations);
      } else {
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setHasLoaded(true);
    }
  };

  useEffect(() => {
    getWorkStations();
  }, []);

  if (hasLoaded)
    return (
      <>
        <Autocomplete
          value={value}
          loading={loading}
          fullWidth={isSmallScreen}
          // disablePortal
          clearOnBlur
          selectOnFocus
          disabled={disabled}
          onChange={(Event, newValue, reason, details) => {
            //   if (reason == "selectOption") setValue(newValue);
            if (onUpdate) onUpdate(newValue ?? null);
          }}
          getOptionLabel={(option) => {
            // If we're passing in empty object with only the user id, then return the equivalent name from the list
            if (!option.name && option.id) {
              let workStation = workStations.find(
                (workStation) => workStation.id == option.id
              );
              if (workStation)
                return `Station #${workStation.id} - ${workStation.name}`;
              else return null;
            }

            return `Station #${option.id} - ${option.name}`;
          }}
          options={workStations}
          isOptionEqualToValue={(option, value) => {
            if (!value) return false;
            return option.id === value.id;
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size={props.size ? props.size : "small"}
              label={label}
              sx={{
                width: "100%",
              }}
              variant="outlined" // filled, outlined, standard
              InputProps={{
                ...params.InputProps,
                onKeyDown: (e) => {
                  if (!enableAdd && e.key === "Enter") {
                    e.stopPropagation();
                  }
                },
                endAdornment: <>{params.InputProps.endAdornment}</>,
              }}
              onBlur={onBlur}
              error={error}
              helperText={helperText}
              required={required}
            />
          )}
        />
      </>
    );
};

export default SelectWorkStation;
